import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { ChipFilter, ChipFilterValue } from './chips-filter.model';

/**
 * Rows of filter chips ("Category · All · Financial 7 …"). It only shows and reports the
 * selection; the host (e.g. lib-filtered-table) keeps it in the URL and reloads the list.
 */
@Component({
  selector: 'lib-chips-filter',
  imports: [TranslocoPipe],
  templateUrl: './chips-filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  host: { class: 'flex flex-col gap-sm' },
})
export class ChipsFilterComponent {
  readonly filters = input<ChipFilter[]>([]);
  readonly value = input<ChipFilterValue>({});

  readonly valueChange = output<ChipFilterValue>();

  protected selected(key: string): string[] {
    return this.value()[key] ?? [];
  }

  protected isSelected(key: string, optionValue: string): boolean {
    return this.selected(key).includes(optionValue);
  }

  selectAll(filter: ChipFilter): void {
    this.emit(filter.key, []);
  }

  /** Clicking a selected chip clears it; single filters replace, multiple ones toggle. */
  toggle(filter: ChipFilter, optionValue: string): void {
    const current = this.selected(filter.key);
    const isSelected = current.includes(optionValue);
    if (filter.multiple) {
      this.emit(
        filter.key,
        isSelected
          ? current.filter(item => item !== optionValue)
          : [...current, optionValue]
      );
      return;
    }
    this.emit(filter.key, isSelected ? [] : [optionValue]);
  }

  private emit(key: string, values: string[]): void {
    this.valueChange.emit({ ...this.value(), [key]: values });
  }
}
